/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const MAX_RECORDING_DURATION_IN_SECONDS = 120;
export const MAX_RECORDING_DURATION_IN_MINUTES = 2;
export const COUNTDOWN_TIME_IN_SECONDS = 3;

export const BACKGROUND_BLUR_PX = 3;

export const VIDEO_MIME_TYPE = 'video/mp4';
export const VIDEO_FILE_TYPE = 'mp4';

export const AUDIO_MIME_TYPE = 'audio/mpeg';
export const AUDIO_FILE_TYPE = 'mp3';

export const PHOTO_MIME_TYPE = 'image/jpeg';
export const PHOTO_FILE_TYPE = 'jpeg';

export const SETTINGS_POPUP_ZINDEX = 11;

export const VIDEO_EFFECTS = { NONE: 'none', BLUR: 'blur' };
